import script from "./DataBase.vue?vue&type=script&setup=true&lang=js"
export * from "./DataBase.vue?vue&type=script&setup=true&lang=js"

import "./DataBase.vue?vue&type=style&index=0&id=4cd1edb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd1edb1"]])

export default __exports__